"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconDisabled', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M8 0C12.4116 0 16 3.58844 16 8C16 12.4116 12.4116 16 8 16C3.58844 16 0 12.4116 0 8C0 3.58844 3.58844 0 8 0ZM8 14.2222C11.4302 14.2222 14.2222 11.4302 14.2222 8C14.2222 6.60468 13.7602 5.31497 12.9813 4.27582L4.27582 12.9813C5.31497 13.7602 6.60468 14.2222 8 14.2222ZM3.01874 11.7242C2.23975 10.685 1.77778 9.39532 1.77778 8C1.77778 4.56978 4.56978 1.77778 8 1.77778C9.39532 1.77778 10.685 2.23975 11.7242 3.01874L3.01874 11.7242Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M10.05 0C15.5645 0 20.05 4.48556 20.05 10C20.05 15.5144 15.5645 20 10.05 20C4.5356 20 0.0500488 15.5144 0.0500488 10C0.0500488 4.48556 4.5356 0 10.05 0ZM10.0501 18C14.4604 18 18.0501 14.4103 18.0501 10C18.0501 8.15437 17.4214 6.45245 16.367 5.09718L5.14725 16.317C6.50252 17.3713 8.20445 18 10.0501 18ZM3.73305 14.9028C2.67871 13.5475 2.05007 11.8456 2.05007 10C2.05007 5.58971 5.63979 2 10.0501 2C11.8957 2 13.5976 2.62864 14.9528 3.68297L3.73305 14.9028Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M12.0601 0C18.6774 0 24.0601 5.38267 24.0601 12C24.0601 18.6173 18.6774 24 12.0601 24C5.44272 24 0.0600567 18.6173 0.0600567 12C0.0600567 5.38267 5.44272 0 12.0601 0ZM12.0601 21.6C17.3524 21.6 21.6601 17.2923 21.6601 12C21.6601 9.78525 20.9057 7.74295 19.6405 6.11662L6.1767 19.5804C7.80303 20.8456 9.84533 21.6 12.0601 21.6ZM4.47965 17.8833C3.21445 16.257 2.46008 14.2147 2.46008 12C2.46008 6.70766 6.76774 2.4 12.0601 2.4C14.2748 2.4 16.3171 3.15436 17.9434 4.41957L4.47965 17.8833Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M16.0801 0C24.9032 0 32.0801 7.17689 32.0801 16C32.0801 24.8231 24.9032 32 16.0801 32C7.25697 32 0.0800781 24.8231 0.0800781 16C0.0800781 7.17689 7.25697 0 16.0801 0ZM16.0801 28.8C23.1366 28.8 28.8801 23.0565 28.8801 16C28.8801 13.047 27.8743 10.3239 26.1873 8.1555L8.23561 26.1072C10.404 27.7942 13.1271 28.8 16.0801 28.8ZM5.97288 23.8444C4.28593 21.676 3.28012 18.953 3.28012 16C3.28012 8.94355 9.02366 3.20001 16.0801 3.20001C19.0331 3.20001 21.7561 4.20583 23.9245 5.89277L5.97288 23.8444Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;